export default __webpack_public_path__ + "static/meltybezel-7f75fca39d74a90e8aa6f53132519262.png";